
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"25","height":"21"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#9B9B9B","fill-rule":"evenodd","d":"M11.052 3.23L9.129.54 8.964.312H0v20.083h25V3.23H11.052zm13.114.832v2.083H13.14l-1.492-2.083h12.517zM.834 19.563V1.147h7.7l2.084 2.915 1.96 2.73c.08.114.209.173.34.173l11.248.015v12.583H.834z"}})])
          )
        }
      }
    